import { helper } from '@ember/component/helper'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { subscriptionTypeToThemeKey } from 'teacher-ui-client/utils/themes'
import { isSubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

interface Signature {
  Args: {
    Positional: [subscriptionType: unknown]
  }
  Return: ThemeKeys | undefined
}

/**
 * Provide a subscription type, get back a theme key. This theme key can be used to make color-based UI decisions in JS.
 *
 * {{theme-key "reading"}} -> "blue"
 * {{theme-key "maths"}} -> "green"
 */
export const themeKey = helper<Signature>(function ([subscriptionType]) {
  return isSubscriptionType(subscriptionType) ? subscriptionTypeToThemeKey(subscriptionType) : undefined
})

export default themeKey
